import { BlankSlate } from "@msuite/ui/blank-slate";
import { ContentBox } from "@msuite/ui/content-box";
import { icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { DataTable } from "@msuite/ui/table";
import { Can } from "@/components/citadel";
import { useVehicles } from "@/hooks/use-vehicles";
import { columns } from "./table-config";
import { VehiclesMenu } from "./vehicles-menu";

export function Vehicles() {
	/** Hooks */
	const { t } = useTranslation();
	const { vehicles, isLoading, queryKey, refetch } = useVehicles();

	/** Render */
	return (
		<ContentBox>
			{/* The navigation drops the fleet for a caller without the rule, so this is what a typed
			    address or an old bookmark lands on — a plain statement rather than an empty table. */}
			<Can
				action="read"
				subject="Vehicle"
				fallback={
					<BlankSlate
						Icon={icon("Car")}
						label={t("general.no_access")}
					/>
				}
			>
				<DataTable
					data={vehicles}
					columns={columns}
					isLoading={isLoading}
					queryKey={queryKey}
					refetch={refetch}
					persistenceKey="vehicles-table"
					menu={<VehiclesMenu refetch={refetch} />}
					initialPinningState={{
						start: ["licensePlate"],
					}}
				/>
			</Can>
		</ContentBox>
	);
}
